import { QuestionBase } from '../question-base';

export class AutocompleteDropdownQuestion extends QuestionBase<string> {
  controlType = 'autocomplete-dropdown';
}
